import { render, staticRenderFns } from "./textarea-custom.vue?vue&type=template&id=065cc1a2&scoped=true"
import script from "./textarea-custom.vue?vue&type=script&lang=js"
export * from "./textarea-custom.vue?vue&type=script&lang=js"
import style0 from "./textarea-custom.vue?vue&type=style&index=0&id=065cc1a2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065cc1a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('065cc1a2')) {
      api.createRecord('065cc1a2', component.options)
    } else {
      api.reload('065cc1a2', component.options)
    }
    module.hot.accept("./textarea-custom.vue?vue&type=template&id=065cc1a2&scoped=true", function () {
      api.rerender('065cc1a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/components/form-elements/textarea-custom.vue"
export default component.exports